module.exports = __webpack_public_path__ + "img/schema_verticalisateur_2a.1c6656e3.svg";